let baseURL = location.origin;
switch (baseURL) {
	//正式服
	case "http://cc.fsyg.cn":
	case "https://cc.fsyg.cn":
		baseURL = "https://api.fsyg.cn";
		break;
		//测试服
	case "http://cc-t.fsyg.cn":
	case "https://cc-t.fsyg.cn":
		baseURL = "https://api-t.fsyg.cn";
		break;
	default:
		baseURL = "https://api-t.fsyg.cn";
		break
}
module.exports = {
	baseURL: baseURL,
}



// WEBPACK FOOTER //
// ./src/util/config.js